import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/nl';
export const locale = {
  lang: 'nl',
  data: {
    'GENERICSURVEY': {
      'CATALOGOS': {
        'broker': catalogos.institutos,
      },
      'TITULO': 'Generiek enquêterapport',
      'SUBTITULO': 'Raadpleeg het generieke enquêterapport door in te voeren',
      'CAMPOS': {
        'Token': 'Token:',
      },
      'RESULTADOS': {
        'CARGANDO': 'Zoekresultaten laden',
        'TITULO': 'Resultaten',
        'ENCONTRADAS': 'Totaal aantal gevonden gebruikers',
        'DESCARGAR': 'Informatie downloaden in Excel-formaat',
        'SINRESULTADOS': 'Geen gebruikers gevonden voor het opgegeven token'
      }
    }
  }
};
